import { DeviceSizes, Divider, Link, Typography } from 'beek-design-system';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
import { Audio } from 'src/api/siteMap/siteMap.graphql';

type AudioBooksData = {
  data: Audio[];
  slug: string;
};

const ExtendedDivider = styled(Divider)`
  margin-bottom: 1rem;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 5rem;
`;

const AudioBooksContainer = styled.div`
  display: flex;
  width: 100%;
  @media ${DeviceSizes.mobileM} {
    flex-direction: column;
  }

  @media ${DeviceSizes.laptop} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

type LinkContainerProps = {
  hasMargin: boolean;
};

const LinkContainer = styled.div<LinkContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;

  @media ${DeviceSizes.mobileM} {
    width: 100%;
  }

  @media ${DeviceSizes.laptop} {
    width: 30%;
    margin-right: ${(props): string => (props.hasMargin ? '2.5rem' : '0rem')};
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
`;

const truncateTitle = (title: string): string => `${title.substring(0, 32)}...`;

const AudioBookLinks = (props: AudioBooksData): JSX.Element => {
  const { data, slug } = props;

  const getLinks = (): JSX.Element[] =>
    data.map((item, index) => {
      const { id, prettyTitle } = item;
      const url = `/libros/${item.slug}`;
      if ((index + 1) % 3 === 0) {
        return (
          <LinkContainer
            id={id}
            hasMargin={false}
            key={`Link-item: ${prettyTitle} ${id}`}
            data-cy={`audiobook-title-${prettyTitle}`}
          >
            <Link
              href={url}
              textDecoration="none"
              typographyType="body2"
              colorVariant="gray100"
            >
              {prettyTitle.length >= 32
                ? truncateTitle(prettyTitle)
                : prettyTitle}
            </Link>
          </LinkContainer>
        );
      }
      return (
        <LinkContainer
          id={id}
          hasMargin
          key={`Link-item: ${prettyTitle} ${id}`}
          data-cy={`audiobook-title-${prettyTitle}`}
        >
          <Link
            href={url}
            textDecoration="none"
            typographyType="body2"
            colorVariant="gray100"
          >
            {prettyTitle.length >= 32
              ? truncateTitle(prettyTitle)
              : prettyTitle}
          </Link>
        </LinkContainer>
      );
    });

  const title = (): string => {
    if (data.length > 0) {
      const initial =
        data[0].prettyTitle.length >= 32
          ? truncateTitle(data[0].prettyTitle)
          : data[0].prettyTitle;
      const final =
        data[data.length - 1].prettyTitle.length >= 32
          ? truncateTitle(data[data.length - 1].prettyTitle)
          : data[data.length - 1].prettyTitle;
      return `Resultados para ${initial} - ${final}`;
    }
    return `No se encontraron resultados para "${slug}"`;
  };

  const textColor = data.length > 0 ? 'gray100' : 'gray50';

  return (
    <Container>
      <TitleContainer>
        <Typography type="subtitle1" colorVariant={textColor}>
          {title()}
        </Typography>
      </TitleContainer>
      <ExtendedDivider />
      <AudioBooksContainer>{getLinks()}</AudioBooksContainer>
    </Container>
  );
};
export default AudioBookLinks;
